import { LAUNDRY_GRID_COLS } from '../constants/index';

export const getGridClasses = (gridSizes) => {
  return Object.entries(gridSizes)
    .map(([size, cols]) => LAUNDRY_GRID_COLS[size]?.[cols] || '')
    .filter(Boolean)
    .join(' ');
};